import React, {MouseEventHandler, useContext, useEffect, useState} from "react";
import {AppContext} from "../App";
import './MainScreen.css'
import MenuRow from "./items/promo/MenuRow";
import {ICity, IContest} from "./model/B2CInfo";
import HeaderLogo from "./HeaderLogo";
import UserAvatar from "./header/Avatar";
import YandexProjectLogo from "./footer/YandexProjectLogo";
import close from "../imgs/contest_close.png";

export interface IContestPromoProps {
    contest: IContest
    isMobile: boolean
}

export default function ContestPromo(props: IContestPromoProps) {
    const contest = props.contest
    const [closed, setClosed] = useState(false)
    const [showContest, setShowContest] = useState(!props.isMobile);
    const [visible, setVisible] = useState(true);

    // @ts-ignore
    const handleScroll = (event) => {
        const scroll =
            document.body.scrollTop || document.documentElement.scrollTop;
        setShowContest(!closed && (scroll > 450 || !props.isMobile));
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        }
    }, []);

    return <div className={props.isMobile ? "Content_promo_container_mobile" : "Content_promo_container"}>
        {visible &&
            <ContestPromoBody contest={contest} show={showContest && !closed} onClose={(e) => {
                setClosed(true)
                setTimeout(() => setVisible(false), 200)
            }} />
        }
    </div>
}

export interface IContestPromoBodyProps {
    contest: IContest
    show: boolean
    onClose: MouseEventHandler
}

function ContestPromoBody(props: IContestPromoBodyProps) {
    const contest = props.contest
    return <div className={props.show ? "Contest_promo_fixed" : "Contest_promo_fixed_hidden"}>
        <img className="Contest_promo_close" src={close} onClick={props.onClose} />
        <img className="Contest_sahara_img" src={contest.image} />
        <button className="Contest_ok" onClick={(e) => {
                window.open(contest.link, "_blank")
            }}>
            <span className="Contest_button_message">{contest.button}</span>
        </button>
        <span className="Contest_title">{contest.title}</span>
        <span className="Contest_message">{contest.message}</span>
    </div>
}
